import { NON_BREAKING_SPACE_CHARACTER } from '../constants';
export function makeSpacesNonBreakable(value) {
  return value.replaceAll(' ', NON_BREAKING_SPACE_CHARACTER);
}